import { render, staticRenderFns } from "./ModalCandidate.vue?vue&type=template&id=10bde026"
import script from "./ModalCandidate.vue?vue&type=script&lang=js"
export * from "./ModalCandidate.vue?vue&type=script&lang=js"
import style0 from "./ModalCandidate.vue?vue&type=style&index=0&id=10bde026&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports